// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fixed-label-height[data-v-945d3cd4]{min-height:3em}", ""]);
// Exports
module.exports = exports;
